export type BufferUnits = 'ft' | 'yd' | 'mi' | 'NM' | 'm' | 'km';

export class BufferSrc {
	buffer: number;
	units: BufferUnits;
	value: number;
	constructor(buffer: number, units: BufferUnits) {
		this.Update(buffer, units);
	}
	static Convert(bufferSrc: BufferSrc) {
		switch (bufferSrc.units) {
			case 'ft':
				bufferSrc.value = bufferSrc.buffer / 3.28084;
				break;
			case 'yd':
				bufferSrc.value = bufferSrc.buffer / 1.09361;
				break;
			case 'mi':
				bufferSrc.value = bufferSrc.buffer / 0.0006213671;
				break;
			case 'NM':
				bufferSrc.value = bufferSrc.buffer / 0.000539957;
				break;
			case 'm':
				bufferSrc.value = bufferSrc.buffer;
				break;
			case 'km':
				bufferSrc.value = bufferSrc.buffer / 0.001;
				break;
		}
	}
	Update(buffer: number, units: BufferUnits) {
		this.buffer = buffer;
		this.units = units;
		BufferSrc.Convert(this);

	}

}
